export * from './lib/locale-date.pipe.module';

export { AccredibleLocaleDatePipe } from './lib/locale-date.pipe';
